import { ConfigService } from '@maia/config';
import { HttpService } from '@maia/httpClient';
import { BrokerService } from '@maia/shared';
import { BrokerController } from './broker.controller';

export class BrokerFactory {
  private readonly configService = new ConfigService();
  private readonly httpService = new HttpService(this.configService, 'apiUrl');

  createBrokerController(): BrokerController {
    return new BrokerController(this.createBrokerService());
  }

  private createBrokerService(): BrokerService {
    return new BrokerService(this.httpService, this.configService);
  }
}

const factory = new BrokerFactory();
export const service = factory.createBrokerController();
